import getIdForModel from "helpers/idHelper";

export const generateCampaignCard = (targetRecipient, donationFormData) => {
  const urlPrefix = targetRecipient?.id !== getIdForModel(donationFormData?.recipientId) ? "fundraiser" : "project";
  const getProgressPercent = (collected, total) => {
    if (!total || collected == null) {
      return 0;
    }
    return Math.ceil((collected / total) * 100);
  };
  return {
    currency: donationFormData?.campaignCurrency.toUpperCase(),
    currencySymbol: donationFormData?.campaignCurrencySymbol,
    image: targetRecipient?.camp_image,
    isActive:
      targetRecipient?.camp_status === "live" || donationFormData?.recipient.camp_status === "live",
    moneyRaised: targetRecipient?.camp_amount_collected,
    target: targetRecipient?.camp_amount,
    collectedTargetHidden:
      urlPrefix === "project" ? donationFormData?.collectedTargetHidden : false,
    collectedTargetProgressPercentHidden:
      urlPrefix === "project" ? donationFormData?.collectedTargetProgressPercentHidden : false,
    collectedTargetProgressPercent:
      urlPrefix === "project"
        ? donationFormData?.collectedTargetProgressPercent
        : getProgressPercent(targetRecipient?.camp_amount_collected, targetRecipient?.camp_amount),
    title: targetRecipient?.title,
    url: `/${urlPrefix}/${targetRecipient?.slug}`,
    user_image: targetRecipient?.photo,
  };
};
